export default "__VITE_ASSET__DEPP6cyy__"